"use client";

import * as React from "react";
import { Ellipsis } from "lucide-react";
import type { ToolbarAction } from "@/components/screen-toolbar";
import { BigButton, List, Row, Sheet } from "./ui";

/**
 * Rodapé de ações do detalhe: ação principal em destaque + "Mais" em folha inferior.
 * Reaproveita as mesmas ações (e diálogos) das telas desktop.
 */
export function ActionFooter({ acoes, permitidas }: { acoes: ToolbarAction[]; permitidas: string[] }) {
  const [aberto, setAberto] = React.useState(false);
  const lista = acoes.filter((a) => permitidas.includes(a.id) && !a.hidden && !a.disabled);
  if (!lista.length) return null;
  const principal = lista.find((a) => a.primary) ?? lista[0];
  const demais = lista.filter((a) => a !== principal);
  return (
    <div className="shrink-0 border-t border-border bg-surface px-4 pt-3 pb-3">
      <div className="flex gap-2">
        <BigButton variant={principal.danger ? "danger" : "primary"} icon={principal.icon} loading={principal.loading} onClick={principal.onClick}>
          {principal.label}
        </BigButton>
        {demais.length ? (
          <button
            type="button"
            aria-label="Mais ações"
            onClick={() => setAberto(true)}
            className="inline-flex h-12 w-14 shrink-0 items-center justify-center rounded-xl border border-border-strong bg-surface active:bg-row-hover"
          >
            <Ellipsis className="size-5" />
          </button>
        ) : null}
      </div>
      <Sheet open={aberto} onOpenChange={setAberto} title="Ações">
        <List className="mb-2">
          {demais.map((a) => (
            <Row
              key={a.id}
              icon={a.icon}
              title={a.label}
              danger={a.danger}
              chevron={false}
              onClick={() => {
                setAberto(false);
                // Deixa a folha fechar antes de abrir o diálogo da ação.
                setTimeout(a.onClick, 160);
              }}
            />
          ))}
        </List>
      </Sheet>
    </div>
  );
}
